import { TicketStatusEnum } from '@gid/models';
import {
  ACTIONABLE_TICKET_STATUSES,
  TicketJobLinkageEnum,
} from '../../store/tickets.module';

/**
 * Filter presets for the ticket console, mirroring the jobs console
 * (jobPresets.js / Jobs.vue). The active preset id is synced to `?view=` and
 * drives the pill bar. Each preset lists only the dimensions it controls;
 * presetToStoreFilter() resets the rest to a baseline so switching presets can
 * never leave stale state behind.
 */
export const TICKET_PRESETS = [
  {
    id: 'inbox',
    labelKey: 'tickets.presets.inbox',
    filters: {
      status: [...ACTIONABLE_TICKET_STATUSES],
      jobLinkage: TicketJobLinkageEnum.ANY,
    },
  },
  {
    id: 'orphans',
    labelKey: 'tickets.presets.orphans',
    filters: {
      status: [...ACTIONABLE_TICKET_STATUSES],
      jobLinkage: TicketJobLinkageEnum.NONE,
    },
  },
  {
    id: 'new',
    labelKey: 'tickets.presets.new',
    filters: {
      status: [TicketStatusEnum.N],
      jobLinkage: TicketJobLinkageEnum.ANY,
    },
  },
  {
    id: 'open',
    labelKey: 'tickets.presets.open',
    filters: {
      status: [TicketStatusEnum.C],
      jobLinkage: TicketJobLinkageEnum.ANY,
    },
  },
  {
    id: 'answered',
    labelKey: 'tickets.presets.answered',
    filters: {
      status: [TicketStatusEnum.A],
      jobLinkage: TicketJobLinkageEnum.ANY,
    },
  },
  {
    id: 'postponed',
    labelKey: 'tickets.presets.postponed',
    filters: {
      status: [TicketStatusEnum.W],
      jobLinkage: TicketJobLinkageEnum.ANY,
    },
  },
  {
    id: 'closed',
    labelKey: 'tickets.presets.closed',
    filters: {
      status: [TicketStatusEnum.L, TicketStatusEnum.R],
      jobLinkage: TicketJobLinkageEnum.ANY,
    },
  },
  {
    id: 'all',
    labelKey: 'tickets.presets.all',
    filters: {
      status: [],
      jobLinkage: TicketJobLinkageEnum.ANY,
    },
  },
];

export const DEFAULT_PRESET_ID = 'inbox';

export function getPreset(id) {
  return TICKET_PRESETS.find((preset) => preset.id === id) || null;
}

/**
 * Turn a preset into a full filter patch. All preset-controlled dimensions are
 * reset to a baseline first, then the preset's own values applied on top.
 */
export function presetToStoreFilter(preset) {
  return {
    status: [],
    jobLinkage: TicketJobLinkageEnum.ANY,
    jobName: null,
    ...(preset ? preset.filters : {}),
  };
}
